import { skipToken, useQuery } from '@tanstack/react-query';

import { AiModels } from '@air/api';
import { type FullWorkspace } from '@air/api/types';
import { type ApiResponse } from '@air/utils-api';
import { isAirrorInstance } from '@air/utils-error';

export const AI_MODELS = 'AI_MODELS';

export const ONE_DAY_MS = 86_400_000;

export type UseAiModelsParams = { workspaceId: FullWorkspace['id'] };
export type AiModelConfig = Extract<ApiResponse<typeof AiModels.getConfigs>['data'][number], { isDefault: false }>;

export const getAiModelsKey = (workspaceId: string) => [AI_MODELS, workspaceId] as const;

export const useAiModels = ({ workspaceId }: UseAiModelsParams) =>
  useQuery({
    queryFn: workspaceId
      ? async () => {
          const result = await AiModels.getConfigs({ filter: { isDefault: false }, workspaceId });

          if (isAirrorInstance(result)) {
            throw result;
          }

          return result.data.filter((m): m is AiModelConfig => !m.isDefault);
        }
      : skipToken,
    queryKey: getAiModelsKey(workspaceId),
    staleTime: ONE_DAY_MS,
  });
